import type { TRule } from 'fela';

export const container: TRule = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
});
